import { AxiosInstance } from 'axios';
import { ServiceGroupsRepository } from '@/model/repository/manager/serviceGroups/ServiceGroupsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ServiceGroupsRepository => ({
    index() {
      return Repository.get(resource);
    },
  });
